<!--
 * @Description: 
 * @Author: pliybird
 * @Date: 2025-10-14 16:04:21
 * @LastEditTime: 2025-10-22 10:52:07
 * @LastEditors: pliybird
 * @filePath: Do not edit
-->
<template>
  <div class="change-lang ml--30 has-droupdown has-menu-child-item">
    <button
      class="hamberger-button"
      @click.stop="AppFunctions.toggleClass('.change-lang', 'active')"
    >
      <!-- <img :src="defaultLangIcon" alt="" /> -->
      {{ defaultLangName }}
    </button>
    <ul class="list">
      <li
        v-for="(item, index) in langList"
        :key="index"
        @click="changeLanguage(item)"
      >
        <span>{{ item.remark }}</span>
      </li>
      <!-- <li v-for="(item,index) in langList" :key="index" @click="changeLanguage(item)"><img :src="item.icon" alt="" /></li> -->
    </ul>
  </div>
</template>
<script>
import AppFunctions from "../../../helpers/AppFunctions";
export default {
  name: "ChangeLanguage",

  data() {
    return {
      AppFunctions,
      langList: [
        {
          name: "zh_CN",
          remark: "CN",
          active: true,
          icon: require("@/assets/images/header/cn.svg"),
        },
        {
          name: "en_US",
          remark: "EN",
          active: false,
          icon: require("@/assets/images/header/usa.svg"),
        },
        {
          name: "ja_JP",
          remark: "JP",
          active: false,
          icon: require("@/assets/images/header/jp.svg"),
        },
      ],
    };
  },
  computed: {
    defaultLangName() {
      return this.langList.filter((item) => item.name == this.$i18n.locale)[0]
        .remark;
    },
    defaultLangIcon() {
      return this.langList.filter((item) => item.name == this.$i18n.locale)[0]
        .icon;
    },
  },
  methods: {
    // 多语言切换
    changeLanguage(item) {
      console.log("多语言切换:", item);
      AppFunctions.removeClass(".change-lang", "active");
      if (item.name === this.$i18n.locale) return;
      let lang = item.name;
      // window.sessionStorage.setItem('lang',lang)

      // this.$i18n.locale = lang
      // this.$router.push({ name: 'Home', params: { lang: lang } })
      this.$router.replace({
        name: item.name === "zh_CN" ? "Home" : "SinglePageHome",
        params: { lang },
      });

      // location.reload()
    },
  },
};
</script>
<style lang="scss" scoped>
.change-lang {
  margin-left: 10px !important;
  cursor: pointer;
  .hamberger-button {
    color: #ffffff;
    background-color: #1457df;
    font-size: 14px;
    font-weight: 600;
  }
  img {
    width: 30px;
  }
  position: relative;

  .list {
    transition: 0.3s;
    opacity: 0;
    visibility: hidden;
    margin-top: 10px;
    position: absolute;
    background-color: var(--color-white);
    list-style: none;
    padding: 10px 4px;
    width: 60px;
    top: 90%;
    left: 50%;
    transform: translateX(-50%);
    margin-bottom: 0;
    border-radius: 4px;
    box-shadow: var(--vyung-card-shadow);
    li {
      // margin-bottom: 15px;
      margin-top: 0;
      text-align: center;
      &:hover {
        background-color: #1457df;
        border-radius: 2px;
        span {
          color: #ffffff;
        }
      }
      span {
        font-size: 16px;
      }
      &:last-child {
        margin-bottom: 0;
      }
    }
  }
  /* &:hover, */
  &.active {
    .list {
      opacity: 1;
      visibility: visible;
      transition: all 0.3s;
      top: 100%;
    }
  }
}
</style>